import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { BookerContext } from '../Booker.js';
import { cn, cnWithPrefix } from 'ui/lib/utils';
import styles from './FieldButton.module.css';
const FieldButton = ({ children, className, type }) => {
    const { useTailwindPrefix, showLabels, version, vertical, buttonNoPadding } = useContext(BookerContext);
    const customCn = useTailwindPrefix ? cnWithPrefix('tw-') : cn;
    return (_jsx("button", Object.assign({ type: type, className: customCn('itm-booker-field', Object.assign({}, (!useTailwindPrefix
            ? {
                'w-full text-primary-booker-a11y hover:bg-primary-booker-10 bg-primary-booker px-3 whitespace-nowrap overflow-hidden text-ellipsis leading-[45px] border border-primary-booker-border rounded': true,
                'md:rounded-none': !vertical && version !== 'padded',
                'md:rounded-2xl': !vertical && version === 'padded' && !buttonNoPadding,
                'md:-mt-[4px]': !vertical && version === 'padded' && showLabels && !buttonNoPadding,
                'md:h-full md:rounded-l-none button-no-padding': !vertical && version === 'padded' && buttonNoPadding,
                [styles.buttonNoPadding]: !vertical && version === 'padded' && buttonNoPadding,
            }
            : {
                'tw-w-full tw-text-primary-booker-a11y hover:tw-bg-primary-booker-10 tw-bg-primary-booker tw-px-3 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-leading-[45px] tw-border tw-border-primary-booker-border tw-rounded': true,
                'md:tw-rounded-none': !vertical && version !== 'padded',
                'md:tw-rounded-2xl': !vertical && version === 'padded' && !buttonNoPadding,
                'md:-tw-mt-[4px]': !vertical && version === 'padded' && showLabels && !buttonNoPadding,
                'md:tw-h-full md:tw-rounded-l-none button-no-padding': !vertical && version === 'padded' && buttonNoPadding,
                [styles.buttonNoPadding]: !vertical && version === 'padded' && buttonNoPadding,
            })), className) }, { children: children })));
};
export default FieldButton;
